import { Box } from '@mui/material';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function a11yProps(index: number) {
    return {
        id: `lessons-tab-${index}`,
        'aria-controls': `lessons-tabpanel-${index}`,
    };
}

export function LessonsTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return value === index ? (
        <div style={{ display: 'flex', flex: 1 }} role='tabpanel' hidden={value !== index} id={`lessons-tabpanel-${index}`} aria-labelledby={`lessons-tab-${index}`} {...other}>
            <Box sx={{ width: '100%' }}>{children}</Box>
        </div>
    ) : null;
}
